import { IIconBase } from '..'

const arrowHLIcon = ({
  color = '#131523',
  height = 17,
  width = 16,
}: IIconBase) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 16 17'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_6528_16292)'>
        <rect
          width={width}
          height={height}
          transform='translate(0 0.5)'
          fill='white'
          fillOpacity='0.01'
        />
        <path
          d='M6.38065 4.45337L2.33398 8.50004L6.38065 12.5467'
          stroke={color}
          strokeWidth='1.5'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M13.6673 8.5H2.44727'
          stroke={color}
          strokeWidth='1.5'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
      <defs>
        <clipPath id='clip0_6528_16292'>
          <rect
            width={width}
            height={height}
            fill='white'
            transform='translate(0 0.5)'
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export default arrowHLIcon
